const TrashIcon = ({ size = 25, fill = '#231F20' }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.293 3.64844L16.293 4.64844H19.793V6.64844H5.79297V4.64844H9.29297L10.293 3.64844H15.293ZM6.79297 21.6484H18.793V7.64844H6.79297V21.6484ZM8.79297 9.64844H16.793V19.6484H8.79297V9.64844Z"
        fill={fill}
      />
    </svg>
  );
};

export default TrashIcon;
